import { render, staticRenderFns } from "./TaskDetailComponent.vue?vue&type=template&id=46299a98&scoped=true&"
import script from "./TaskDetailComponent.vue?vue&type=script&lang=js&"
export * from "./TaskDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailComponent.vue?vue&type=style&index=0&id=46299a98&prod&lang=scss&scoped=true&"
import style1 from "./TaskDetailComponent.vue?vue&type=style&index=1&id=46299a98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46299a98",
  null
  
)

export default component.exports